import { PlausibleEvent } from 'enums/plausible'
import { useEffect } from 'react'
import usePlausible from 'utils/hooks/usePlausible'
import { useInfoProviderContext } from 'utils/providers/InfoProvider/InfoProviderContext'

import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useRouter } from 'next/router'

import TelegramAuthLayout from 'layouts/TelegramAuthLayout'

import RegisterByTelegramForm from 'components/RegisterByTelegramForm/RegisterByTelegramForm'

const DynamicRestrictedModal = dynamic(() => import('components/RestrictedModal'))

const TelegramSignUp = ({ referrer }: { referrer: string }) => {
  const router = useRouter()

  useEffect(() => {
    const exitingFunction = () => {
      localStorage.removeItem('registeringFromPopup')
    }

    router.events.on('routeChangeStart', exitingFunction)

    return () => {
      router.events.off('routeChangeStart', exitingFunction)
    }
  }, [])

  const setEvent = usePlausible()

  useEffect(
    () =>
      setEvent(PlausibleEvent.OpenedSignUp, {
        step: 1,
        source: router.query?.from as string,
        referrer,
      }),
    [],
  )

  const info = useInfoProviderContext()

  if (info?.restricted === true) {
    return <DynamicRestrictedModal />
  }

  return (
    <>
      <Head>
        <title>Binany register | choose currency</title>
      </Head>
      <TelegramAuthLayout>
        <RegisterByTelegramForm />
      </TelegramAuthLayout>
    </>
  )
}

export default TelegramSignUp

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['main', 'contacts', 'shared', 'error'])),
    },
  }
}
